import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ThumbDown = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.55484 20.6452C10.25 20.9928 11.0916 20.8356 11.6144 20.2605L15.9424 15.4998H19C20.1046 15.4998 21 14.6043 21 13.4998V5.49975C21 4.39519 20.1046 3.49976 19 3.49976H7.61803C6.86049 3.49976 6.16796 3.92776 5.82918 4.60533L3.21115 9.8414C3.07229 10.1191 3 10.4253 3 10.7358V13.4998C3 14.6043 3.89543 15.4998 5 15.4998H9.2802L8.6295 18.7532C8.47607 19.5204 8.85508 20.2953 9.55484 20.6452ZM14.5 14.1131L10.7784 18.2069L11.4806 14.6959C11.5393 14.4021 11.4633 14.0975 11.2733 13.8658C11.0834 13.6341 10.7996 13.4998 10.5 13.4998H5V10.7358L7.61803 5.49975H14.5V14.1131ZM16.5 13.4998H19V5.49975H16.5V13.4998Z"
      fill="currentColor"
    />
  </Icon>
));

export default ThumbDown;
